// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Mcp_Wheel-loader{top:0;left:0;height:100%;width:100%;display:flex;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8);z-index:99;opacity:0;pointer-events:none}.Mcp_Wheel-loader.fixed{position:fixed}.Mcp_Wheel-loader.display{opacity:1;transition:opacity .2s ease-in-out;pointer-events:all}.Mcp_Wheel-loader.display svg{-webkit-animation:loaderWheelRollAndScale 3s infinite;animation:loaderWheelRollAndScale 3s infinite;transform:rotate(30deg);fill:#ec3d2d}", ""]);
// Exports
module.exports = exports;
